import React from 'react';
import { graphql } from 'graphql';
import Container from './Container';
import {
  ContentWysiwyg,
  ContactBlocks,
  ContentAccordion,
  ReusableBlock,
  InfoBlocks,
  Card,
  CardMerger,
  LinkBlocks,
  LinkList,
  EmbedBlock,
  Video,
  Files,
  CheckList,
  LargeLinkTile,
  AppButtons,
  AppBlock
} from '.';

const bundleMap = {
  "container": Container,
  "content_wysiwyg": ContentWysiwyg,
  "content_accordion": ContentAccordion,
  "reusable_block": ReusableBlock,
  "info_blocks": InfoBlocks,
  "card": Card,
  "card_merger": CardMerger,
  "link_list": LinkList,
  "embed_block": EmbedBlock,
  "video": Video,
  "files": Files,
  "link_blocks": LinkBlocks,
  "contact_blocks": ContactBlocks,
  "checklist": CheckList,
  "large_link_tile": LargeLinkTile,
  "app_buttons": AppButtons,
  "app_block": AppBlock,
}

const Paragraph = ({ entity, even, overrideProps }) => {
  const Component = bundleMap[entity.entityBundle];
  if (Component) {
    const props = (overrideProps && overrideProps[entity.entityBundle]) || {};
    props.entity = entity;
    props.even = even;
    return <Component {...props} />
  } else {
    return (
      <section>
        Not implemented: {entity.entityBundle}
      </section>
    )
  }
}


export default Paragraph;
